export const LOAN_BLOTTER_PREFIX = 'principal/loans';
